
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    FormControl,
    InputLabel,
    Select,
    Alert,
    Snackbar,
    MenuItem,
    Button
} from "@mui/material";

import { useGetAllCarsPlateNumberQuery, useGetAllCarsQuery } from "../../../redux/slices/seller/sale/allCarPlateNumber.js";

import {
    useGetAllProductsForSalesQuery,
    useGetProductsForSalesByPlateNumberQuery,
    useAddSaleMutation
} from "../../../redux/slices/seller/sale/allProductSlince.js";
import { Pagination } from "@mui/material";
import { useOutletContext } from "react-router-dom";

import "../../../styles/seller.css/sale-css/add-sale.css";

export default function AddSale() {
    const { sidebarOpen, activeLog, setActiveLog } = useOutletContext();
    const [buyerType, setBuyerType] = useState("Maşın");
    const [selectedPlate, setSelectedPlate] = useState("all");
    const [searchDisabled, setSearchDisabled] = useState(false);
    const [numpadMode, setNumpadMode] = useState("quantity")
    const [openServicePriceNumpad, setOpenServicePriceNumpad] = useState(false);
    const [serviceTempPrice, setServiceTempPrice] = useState("");
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;
    const [productPage, setProductPage] = useState(1);
    const productsPerPage = 50;

    const { data, isLoading } = useGetAllCarsPlateNumberQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnReconnect: true,
        refetchOnFocus: true
    });
    const plateNumbers = data?.data || [];

    const { data: allCarsData, isLoading: logsLoading } = useGetAllCarsQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnReconnect: true,
        refetchOnFocus: true
    });
    const logs = allCarsData?.data || [];

    const [addSale] = useAddSaleMutation();

    function useProducts(selectedPlate, buyerType, activeLog) {
        const shouldFetchAll = buyerType === "Əl ilə" || buyerType === "Umico" || selectedPlate === "all";
        const shouldFetchByPlate = buyerType === "Maşın" && !!activeLog && selectedPlate !== "all";

        const { data: allProducts, isLoading: isAllLoading, refetch: refetchAll } = useGetAllProductsForSalesQuery(undefined, {
            skip: !shouldFetchAll,
            refetchOnMountOrArgChange: true,
            refetchOnReconnect: true
        });

        const { data: plateProducts, isLoading: isPlateLoading, refetch: refetchByPlate } = useGetProductsForSalesByPlateNumberQuery(selectedPlate, {
            skip: !shouldFetchByPlate,
            refetchOnMountOrArgChange: true,
            refetchOnReconnect: true
        });


        let resultData = [];
        let resultLoading = false;

        if (shouldFetchAll) {
            resultData = allProducts?.data || [];
            resultLoading = isAllLoading;
        } else if (shouldFetchByPlate) {
            resultData = plateProducts?.data || [];
            resultLoading = isPlateLoading;
        }


        return {
            data: resultData,
            isLoading: resultLoading,
            refetchAll,
            refetchByPlate
        };
    }


    const handleSelectPlate = (plateNumber) => {
        setSelectedPlate(plateNumber);
    };


    const {
        data: products,
        isLoading: productsLoading,
        refetchAll,
        refetchByPlate
    } = useProducts(selectedPlate, buyerType, activeLog);

    const [km, setKm] = useState("");
    const [nextKm, setNextKm] = useState("");
    const [openNextNumpad, setOpenNextNumpad] = useState(false);
    const [openNumpad, setOpenNumpad] = useState(false);
    const [paymentType, setPaymentType] = useState("Naxd");

    const [searchTerm, setSearchTerm] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [openPayment, setOpenPayment] = useState(false);

    const [plateSearch, setPlateSearch] = useState("");

    const [animatedId, setAnimatedId] = useState(null);
    const [lockClick, setLockClick] = useState(false);

    const [extraHeight, setExtraHeight] = useState(0);

    const [openQtyNumpad, setOpenQtyNumpad] = useState(false);
    const [currentQtyId, setCurrentQtyId] = useState(null);
    const [tempQty, setTempQty] = useState("");

    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1300);

    const [toast, setToast] = useState({ open: false, severity: "success", message: "" });

    const handleCloseToast = () => {
        setToast({ ...toast, open: false });
    };

    const formatPrice = (price) => {

        const p = parseFloat(price);
        if (isNaN(p)) return "0.00";
        return p.toFixed(2);
    };

    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth <= 1300);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const truncateText = (text, max = 25) => {
        if (!text) return "";
        return text.length > max ? text.slice(0, max) + "..." : text;
    };

    const totalAmount = selectedProducts.reduce((acc, curr) => {
        return acc + (Number(curr.totalPrice) || 0);
    }, 0);
    const [cash, setCash] = useState("");
    const [card, setCard] = useState("");
    const [change, setChange] = useState(0);



    const getUsernameFromToken = () => {
        const token = localStorage.getItem("token");
        if (!token) return "";

        try {
            const payload = JSON.parse(atob(token.split(".")[1]));

            return (
                payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
                payload.username ||
                payload.name ||
                ""
            );
        } catch (err) {
            console.error("Token parse xətası:", err);
            return "";
        }
    };



    const sellerName = getUsernameFromToken();




    const sendProductsToWhatsApp = (payload) => {
        if (!payload) {
            console.warn("WhatsApp açılmadı: payload yoxdur");
            return;
        }

        const phoneRaw = activeLog?.phoneNumber;
        if (!phoneRaw) {
            console.warn("WhatsApp açılmadı: phone yoxdur");
            return;
        }

        let phone = phoneRaw.replace(/\D/g, "");


        if (phone.length === 9) {
            phone = "994" + phone;
        }


        else if (phone.length === 10 && phone.startsWith("0")) {
            phone = "994" + phone.slice(1);
        }


        else if (phone.length === 12 && phone.startsWith("994")) {

        }

        else {
            console.warn("WhatsApp açılmadı: phone uyğun deyil", phone);
            return;
        }




        const productsText = [...selectedProducts]
            .filter((prod, index) => payload.items[index] && payload.items[index].productId !== null)
            .sort((a, b) => {
                const filters = ["Hava filtiri", "Yağ filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri"];
                return filters.includes(a.subCategory) - filters.includes(b.subCategory);
            })
            .map((prod, i) => {
                const discount = Number(prod.totalDiscount) || 0;
                const finalPrice = Number(prod.totalPrice) || 0;
                const sub = prod.subCategory;


                const discountRow = discount > 0 ? `\n    Endirim: ${formatPrice(discount)}₼` : "";

                let content = "";

                if (sub === "Motor yağı" || sub === "Transmissiya yağı") {
                    content = `Məhsul: ${prod.companyName || ""} ${prod.code || ""}
    Qiymət: ${formatPrice(prod.priceByLiter)}₼
    Litr: ${prod.quantity}
    Cəmi: ${formatPrice(finalPrice)}₼`;

                } else if (sub === "Antifriz") {

                    const originalPrice = Number(prod.price);

                    content = `Məhsul: ${prod.name || ""} ${prod.color || ""}
    Qiymət: ${formatPrice(originalPrice)}₼${discountRow}
    Cəmi: ${formatPrice(finalPrice)}₼`;

                } else if (["Hava filtiri", "Yağ filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri"].includes(sub)) {
                    const originalPrice = Number(prod.price);

                    content = `Məhsul: ${sub}
    Qiymət: ${formatPrice(originalPrice)}₼${discountRow}
    Cəmi: ${formatPrice(finalPrice)}₼`;

                } else {
                    const originalPrice = Number(prod.price);

                    content = `Məhsul: ${prod.name || ""}
    Qiymət: ${formatPrice(originalPrice)}₼${discountRow}
    Cəmi: ${formatPrice(finalPrice)}₼`;
                }

                return `${i + 1}) ${content}`;
            })
            .join("\n\n");


        let totalServicePrice = 0;
        const servicesArray = [...selectedProducts]
            .filter((prod, index) => payload.items[index] && payload.items[index].productId === null);


        servicesArray.forEach(prod => {
            const price = Number(prod.totalPrice) || 0;
            totalServicePrice += price;
        });


        const servicesText = servicesArray
            .filter(prod => prod.name !== "Mühərrik yağının dəyişdirilməsi")
            .map((prod, i) => {
                const price = Number(prod.totalPrice) || 0;
                return `${i + 1}) Xidmət: ${prod.name}\n    Qiymət: ${formatPrice(price)}₼`;
            })
            .join("\n\n");

        const clock = new Date();
        const formattedClock = clock.toLocaleString();
        const type = payload.paymentType === "CardAndCash" ? "Kart/Nəğd"
            : payload.paymentType === "Card" ? "Kart"
                : payload.paymentType === "POS-terminal" ? "POS-terminal"
                    : payload.paymentType === "Naxd/POS-terminal" ? "Nəğd/POS-terminal"
                        : "Nəğd";

        const paidTotal = Number(payload.cash || 0) + Number(payload.card || 0);
        const changeAmount = paidTotal > totalAmount ? formatPrice(paidTotal - totalAmount) : "0";

        const mileageText = (payload.mileageAtSale !== undefined && payload.mileageAtSale !== null && payload.mileageAtSale !== "" && payload.mileageAtSale >= 0)
            ? `Hal-hazırda (Km): ${payload.mileageAtSale}\n`
            : "";

        const mileageNextText = (payload.mileageNext !== undefined && payload.mileageNext !== null && payload.mileageNext !== "" && payload.mileageNext >= 0)
            ? `Dəyişəcək (Km): ${payload.mileageNext}\n`
            : "";


        const productPadding = servicesText ? "\n\n" : "\n";

        const productsBlock = productsText
            ? `Alınan məhsullar:\n\n${productsText}${productPadding}`
            : "";

        const servicesBlock = servicesText
            ? `Göstərilən xidmətlər:\n\n${servicesText}\n`
            : "";

        const message = `*AUTO LUX YAĞ MƏRKƏZİ ‘Nİ SEÇDİYİNİZ ÜÇÜN TƏŞƏKKÜR EDİRİK.*

Satış Məlumatları:

Ad: ${activeLog.fullName || "-"}
Model: ${activeLog.model || "-"}
Nömrə nişanı: ${payload.plateNumber || "-"}\n${mileageText}${mileageNextText}
${productsBlock}${servicesBlock}
Satıcı: ${sellerName}
Tarix: ${formattedClock} 

Xidmət haqqı: ${formatPrice(totalServicePrice)}₼
Cəmi: ${formatPrice(totalAmount)}₼ 
Ödəniş növü: ${type}
Qaytarılan: ${changeAmount}₼`;

        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, "_blank");
    };





    const categoryOptionsAll = [
        "Yaxıt və maye məhsulları",
        "Avtomobil aksesuarları",
        "Avtomobil hissələri / ehtiyat hissələri",
        "Xüsusi məhsullar / Digər"
    ];

    const subCategoryOptionsAll = {
        "Yaxıt və maye məhsulları": [
            "Motor yağı",
            "Transmissiya yağı",
            "Karopka yağı",
            "Hidravlik yağ",
            "Antifriz",
            "Soyuducu maye",
            "Şüşə yuyucu",
            "Dizel təmizləyici",
            "Motor təmizləyici",
            "Korroziyaya qarşı sprey",
            "Qapı menteşe sprey",
            "Benzin oktan qaldıran",
            "Dizel setan qaldıran"
        ],
        "Avtomobil aksesuarları": [
            "Lampa",
            "Farlar",
            "LED işıqlar",
            "Akumulator",
            "Təkərlər",
            "Şinlər",
            "Döşəmələr",
            "Oturacaq örtükləri",
            "GPS",
            "Kameralar",
            "Multimedia",
            "Şüşə qaldırıcılar",
            "Qapı qoruyucuları",
            "Direksiyon üzlükləri",
            "Döşəmə paspalar",
            "Konsol örtükləri",
            "Svarovski"
        ],
        "Avtomobil hissələri / ehtiyat hissələri": [
            "Hava filtiri",
            "Yağ filtiri",
            "Yanacaq filtiri",
            "Benzin filtiri",
            "Salon filtiri",
            "Transmissiya filtiri",
            "Disklər",
            "Balatalar",
            "Əyləc mayesi",
            "Kardan mili",
            "Əyləc pedalı",
            "Sükan hissələri",
            "Amortizatorlar",
            "Yaylar",
            "Bələdçi barlar",
            "İnjektorlar",
            "Yanacaq pompaları",
            "Stop işıqları",
            "Flaşerlər"
        ],
        "Xüsusi məhsullar / Digər": [
            "Şampun",
            "Wax",
            "Polish",
            "Mikrofiber dəsmallar",
            "Bagaj örtükləri",
            "Yük bağlayıcı kəmərlər",
            "Dəmir yük qutuları",
            "Avtomobil etiketləri",
            "LED işıqlar dekoru",
            "Spinner / ornamentlər",
            "Oturacaq yastıqları",
            "Masaj aksesuarları",
            "Yanğın söndürən",
            "Təhlükəsizlik üçbucağı",
            "İlk yardım dəsti"
        ]
    };

    const carCategoryOptions = [
        "Yaxıt və maye məhsulları",
        "Avtomobil aksesuarları",
        "Avtomobil hissələri / ehtiyat hissələri"
    ];

    const carSubCategoryOptions = {
        "Yaxıt və maye məhsulları": ["Motor yağı", "Transmissiya yağı", "Hidravlik yağ", "Antifriz", "Benzin oktan qaldıran", "Dizel setan qaldıran"],
        "Avtomobil aksesuarları": ["Svarovski"],
        "Avtomobil hissələri / ehtiyat hissələri": ["Hava filtiri", "Yağ filtiri", "Benzin filtiri", "Salon filtiri", "Transmissiya filtiri", "Əyləc mayesi",]
    };



    const servicesList = [
        "Antifriz mayesinin dəyişdirilməsi",
        "Əyləc sisteminin mayesinin dəyişdirilməsi",
        "Sükan sisteminin (rulevoy) mayesinin dəyişdirilməsi",
        "Müştərinin gətirdiyi yağ ilə dəyişmə",
        "Forsunka və zaslonkanın yuyulması",
        "Karterin sökülməsi və kefkirin yuyulması",
        "Sürətlər qutusunun sökülməsi, təmiri və yığılması",
        "Kondisioner xidməti",
        "Çilingər xidmətləri",
        "Mühərrik yağının dəyişdirilməsi"
    ];

    let categoryOptions = buyerType === "Maşın" ? carCategoryOptions : categoryOptionsAll;
    let subCategoryOptions = buyerType === "Maşın" ? carSubCategoryOptions : subCategoryOptionsAll;

    if (buyerType === "Maşın") {
        categoryOptions = carCategoryOptions;
        subCategoryOptions = carSubCategoryOptions;
    } else {
        categoryOptions = categoryOptionsAll;
        subCategoryOptions = subCategoryOptionsAll;
    }

    const normalizePlate = (v) =>
        v.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

    const filteredLogs = logs.filter(emp => {
        const plateMatch =
            selectedPlate === "all" || emp.plateNumber === selectedPlate;

        const searchMatch =
            !plateSearch ||
            normalizePlate(emp.plateNumber).includes(
                normalizePlate(plateSearch)
            );

        return plateMatch && searchMatch;
    });
    const visibleLogs = activeLog ? [activeLog] : filteredLogs;

    const filteredProducts = products.filter(p => {
        const nameMatch = !searchTerm || p.name.toLowerCase().includes(searchTerm.toLowerCase());

        if (selectedCategory === "all") return nameMatch;

        if (!selectedSubCategory) return nameMatch;

        const subMatch =
            p.subCategory?.trim().toLowerCase() === selectedSubCategory.trim().toLowerCase();

        return subMatch && nameMatch;
    });

    const totalPages = Math.ceil(visibleLogs.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedVisibleLogs = visibleLogs.slice(startIndex, startIndex + itemsPerPage);
    const totalProductPages = Math.ceil(filteredProducts.length / productsPerPage);
    const productStartIndex = (productPage - 1) * productsPerPage;
    const paginatedProducts = filteredProducts.slice(productStartIndex, productStartIndex + productsPerPage);

    const handleServiceSelect = (serviceName) => {
        const exists = selectedProducts.find(prod => prod.name === serviceName && prod.isService);
        if (exists) {
            setToast({ open: true, message: "Bu xidmət artıq əlavə edilib!", severity: "warning" });
            return;
        }

        const newService = {
            id: `service-${Date.now()}`,
            name: serviceName,
            price: 0,
            totalPrice: 0,
            priceByLiter: 0,
            quantity: 1,
            isService: true,
            subCategory: "Xidmət",
            category: "Xidmət",
            code: "-",
            fuelType: "-"
        };

        setSelectedProducts(prev => [...prev, newService]);

        if (window.innerWidth <= 1300) {
            setToast({
                open: true,
                message: "Seçilmiş xidmət əlavə olundu",
                severity: "success"
            });
        }
    };

    const handleCashChange = (e) => {
        let v = e.target.value;
        if (/^\d*\.?\d*$/.test(v)) {
            if (v.length > 1 && v.startsWith("0") && !v.startsWith("0.")) {
                v = v.replace(/^0+/, "");
            }
            setCash(v);
            if (paymentType === "Naxd") {
                const c = Number(v || 0) - totalAmount;
                setChange(c > 0 ? c : 0);
            }
        }
    };



    const addDigit = (digit) => {
        if ((km || "").length >= 6) return;

        if (!km) return setKm(digit);

        if (km === "0") return setKm(digit);

        if (/^0+$/.test(km)) return setKm(digit);

        setKm(prev => prev + digit);
    };


    const handleCardChange = (e) => {
        let v = e.target.value;
        if (/^\d*\.?\d*$/.test(v)) {
            if (v.length > 1 && v.startsWith("0") && !v.startsWith("0.")) {
                v = v.replace(/^0+/, "");
            }
            setCard(v);
        }
    };

    const handleAddProduct = (prod) => {

        if (window.innerWidth <= 1300) {
            if (lockClick) return;
            setLockClick(true);
            setAnimatedId(prod.id);
            setTimeout(() => {
                setAnimatedId(null);
                setLockClick(false);
            }, 600);
        }

        const existing = selectedProducts.find(p => p.id === prod.id);


        const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";


        const bidonLitrForPrice = parseFloat(prod.litr || prod.literForOneBidon) || 1;
        const effectivePrice = (isOil && prod.priceByLiter)
            ? parseFloat(String(prod.priceByLiter).replace(',', '.')) || 0
            : (isOil
                ? (parseFloat(String(prod.price).replace(',', '.')) || 0) / bidonLitrForPrice
                : parseFloat(String(prod.price).replace(',', '.')) || 0);

        const discountAmount = parseFloat(String(prod.discountAmount).replace(',', '.')) || 0;

        let netUnitPrice = 0;
        let discountAppliedPerQtyUnit = 0;

        if (isOil) {
            const bidonLitr = parseFloat(prod.litr || prod.literForOneBidon) || 1;
            discountAppliedPerQtyUnit = discountAmount / bidonLitr;
            netUnitPrice = Math.max(0, effectivePrice - discountAppliedPerQtyUnit);
        } else {
            discountAppliedPerQtyUnit = discountAmount;
            netUnitPrice = Math.max(0, effectivePrice - discountAppliedPerQtyUnit);
        }

        // Client-side stock check (use immutable backend stock fields)
        const stockLimit = isOil
            ? (parseFloat(prod.stockTotalLiter ?? prod.totalLiter) || 0)
            : (parseFloat(prod.stockQuantity ?? prod.quantity) || 0);

        if (existing) {
            const newQty = isOil
                ? parseFloat(existing.quantity || 0) + 1
                : (parseInt(existing.quantity || 0) + 1);

            // Stock validation removed - allow selection even with very low stock

            const finalTotalPrice = netUnitPrice * newQty;
            const finalTotalDiscount = discountAppliedPerQtyUnit * newQty;

            setSelectedProducts(
                selectedProducts.map(p =>
                    p.id === prod.id
                        ? {
                            ...p,
                            quantity: newQty,
                            totalPrice: Number(finalTotalPrice.toFixed(2)),
                            discountAmount: discountAmount, // Keep original bidon/unit discount reference
                            totalDiscount: Number(finalTotalDiscount.toFixed(2))
                        }
                        : p
                )
            );
        } else {
            // Stock validation removed - allow selection even with very low stock
            const finalTotalPrice = netUnitPrice * 1;
            const finalTotalDiscount = discountAppliedPerQtyUnit * 1;
            setSelectedProducts([
                ...selectedProducts,
                {
                    ...prod,
                    quantity: 1,
                    totalPrice: Number(finalTotalPrice.toFixed(2)),
                    discountAmount: discountAmount, // Keep original reference
                    totalDiscount: Number(finalTotalDiscount.toFixed(2))
                }
            ]);
        }
    };



    const handleRemoveProduct = (prodId) => {
        setSelectedProducts(selectedProducts.filter(p => p.id !== prodId));
    };

    const handleQuantityChange = (id, newQty) => {
        setSelectedProducts((prev) =>
            prev.map((prod) => {
                if (prod.id === id) {
                    const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                    const qty = isOil
                        ? parseFloat(String(newQty).replace(',', '.')) || 0
                        : parseInt(newQty) || 0;

                    // Stock limit check (use immutable backend stock fields)
                    const stockLimit = isOil
                        ? (parseFloat(prod.stockTotalLiter ?? prod.totalLiter) || 0)
                        : (parseFloat(prod.stockQuantity ?? prod.quantity) || 0);

                    // Base unit price (before discount)
                    const bidonLitrForPrice = parseFloat(prod.litr || prod.literForOneBidon) || 1;
                    const rawBasePrice = prod.isService
                        ? parseFloat(String(prod.price || 0).replace(',', '.'))
                        : (isOil && prod.priceByLiter
                            ? parseFloat(String(prod.priceByLiter).replace(',', '.'))
                            : (isOil
                                ? (parseFloat(String(prod.salePrice || prod.price || 0).replace(',', '.')) / bidonLitrForPrice)
                                : parseFloat(String(prod.salePrice || prod.price || 0).replace(',', '.'))));
                    const baseUnitPrice = rawBasePrice || 0;

                    const discountAmount = parseFloat(String(prod.discountAmount || 0).replace(',', '.')) || 0;

                    let netUnitPrice = 0;
                    let discountAppliedPerQtyUnit = 0;

                    if (isOil) {
                        // For oil, discount is per bidon, convert to per liter
                        discountAppliedPerQtyUnit = discountAmount / bidonLitrForPrice;
                        netUnitPrice = Math.max(0, baseUnitPrice - discountAppliedPerQtyUnit);
                    } else {
                        discountAppliedPerQtyUnit = discountAmount;
                        netUnitPrice = Math.max(0, baseUnitPrice - discountAppliedPerQtyUnit);
                    }

                    // Stock validation removed - allow selection even with very low stock
                    const finalTotalPrice = netUnitPrice * qty;
                    const finalTotalDiscount = discountAppliedPerQtyUnit * qty;

                    return {
                        ...prod,
                        quantity: newQty,
                        totalPrice: Number(finalTotalPrice.toFixed(2)),
                        totalDiscount: Number(finalTotalDiscount.toFixed(2))
                    };
                }
                return prod;
            })
        );
    };

    const handlePriceChange = (id, newPrice) => {
        setSelectedProducts((prev) =>
            prev.map((prod) => {
                if (prod.id === id) {

                    const priceVal = parseFloat(String(newPrice).replace(',', '.')) || 0;
                    const qty = parseFloat(prod.quantity) || 1;

                    return {
                        ...prod,
                        price: newPrice,
                        totalPrice: Number((priceVal * qty).toFixed(2)),
                    };
                }
                return prod;
            })
        );
    };



    useEffect(() => {
        if (activeLog) {
            const container = document.querySelector(".add-sale-container");
            if (container) {
                container.scrollTop = 0;
            }
        }
    }, [activeLog]);

    useEffect(() => {
        const updateHeight = () => {
            const container = document.querySelector('.add-sale-container');
            const header = document.querySelector('.add-sale-header');
            const divider = document.querySelector('.add-sale-divider');
            const footer = 0;
            if (container && header && divider) {
                const h = container.clientHeight - header.offsetHeight - divider.offsetHeight - footer;
                setExtraHeight(h);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);






    const handleConfirmSale = async () => {


        if (selectedProducts.length === 0) return;

        const payload = {
            plateNumber: buyerType === "Maşın"
                ? (activeLog?.plateNumber || null)
                : selectedPlate && selectedPlate !== "all"
                    ? selectedPlate
                    : null,

            mileageAtSale: buyerType === "Maşın" ? Number(km || 0) : 0,
            mileageNext: buyerType === "Maşın" ? Number(nextKm || 0) : 0,
            isBuyCar: buyerType === "Maşın",
            isUmico: buyerType === "Umico",
            paymentType: paymentType === "Kart" ? "Card"
                : paymentType === "Naxd" ? "Cash"
                    : paymentType === "Kart/Naxd" ? "CardAndCash"
                        : paymentType === "POS-terminal" ? "POS-terminal"
                            : paymentType === "Naxd/POS-terminal" ? "Naxd/POS-terminal"
                                : "Unknown",
            card: (paymentType === "Kart" || paymentType === "Kart/Naxd" || paymentType === "POS-terminal" || paymentType === "Naxd/POS-terminal") ? Number(card || 0) : 0,
            cash: (paymentType === "Naxd" || paymentType === "Kart/Naxd" || paymentType === "Naxd/POS-terminal") ? Number(cash || 0) : 0,

            items: selectedProducts.map(p => {
                const isService = p.id.toString().startsWith("service-");
                if (isService) {
                    return {
                        productId: null,
                        quantity: 0,
                        serviceName: p.name,
                        serviceFee: parseFloat(p.price) || 0,
                        discount: 0
                    };
                } else {
                    return {
                        productId: p.id,
                        quantity: parseFloat(p.quantity) || 1,
                        serviceName: null,
                        serviceFee: 0,
                        discount: parseFloat(p.discountAmount) || 0
                    };
                }
            }),
        };



        try {

            await addSale(payload).unwrap();

            if (payload.isBuyCar) {
                await refetchByPlate();
            } else {
                await refetchAll();
            }


            setToast({
                open: true,
                severity: "success",
                message: "Satış həyata keçirildi!",
            });

            if (payload.isBuyCar) {
                const whatsappPayload = {
                    ...payload,
                    mileageAtSale: buyerType === "Maşın" ? km : 0,
                    mileageNext: buyerType === "Maşın" ? nextKm : 0
                };
                sendProductsToWhatsApp(whatsappPayload);
            }

            setSelectedProducts([]);
            setKm("");
            setNextKm("");
            setCash(0);
            setCard(0);
            setChange(0);
            setOpenPayment(false);



        } catch (err) {
            setToast({
                open: true,
                severity: "error",
                message: err?.data?.message || "Xəta baş verdi!",
            });
            console.error("Xəta:", err);
        }
    };

    const addNextKmDigit = (digit) => {
        setNextKm(prev => {
            const current = prev || "";


            if (current.length >= 6) return current;

            let v = current + digit;


            if (v.length > 1 && v.startsWith("0")) {
                v = v.replace(/^0+/, "");
            }

            return v;
        });
    };

    useEffect(() => {
        setPage(1);
    }, [selectedPlate, buyerType]);

    useEffect(() => {
        setProductPage(1);
    }, [selectedCategory, selectedSubCategory, searchTerm]);



    return (
        <Box className={`add-sale-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="add-sale-header">
                <Box className="add-sale-title">
                    <Typography style={{ color: "#545A61" }}>Satış Əlavə Et</Typography>
                </Box>
                <Box className="add-sale-filter-row">
                    <FormControl size="small" className="add-sale-buyer-type">
                        <InputLabel>Alici</InputLabel>
                        <Select
                            value={buyerType}
                            label="Alici"
                            className="all-select-button"
                            onChange={(e) => {
                                const newType = e.target.value;
                                setBuyerType(newType);

                                if (newType === "Əl ilə" || newType === "Umico") {
                                    setActiveLog({ fake: true });
                                } else {
                                    setActiveLog(null);
                                }
                                setPlateSearch("");
                                setSelectedPlate("all");

                                setSelectedProducts([]);

                                setSelectedCategory("all");
                                setSelectedSubCategory("");

                                setSearchTerm("");

                                setPaymentType("Naxd");
                                setCash("");
                                setCard("");
                                setChange(0);

                                setKm("");
                            }}

                        >
                            <MenuItem value="Maşın">Maşın</MenuItem>
                            <MenuItem value="Əl ilə">Əl ilə</MenuItem>
                            <MenuItem value="Umico">Umico</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl
                        size="small"
                        className="add-sale-plate"
                        disabled={buyerType !== "Maşın" || !!activeLog}
                    >
                        <InputLabel>Nömrə nişanı</InputLabel>
                        <Select
                            value={selectedPlate}
                            label="Satış Əlavə Et"
                            className="all-select-button"
                            onChange={(e) => setSelectedPlate(e.target.value)}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 250,
                                    }
                                }
                            }}
                        >
                            <MenuItem value="all">Hamısı</MenuItem>

                            {isLoading ? (
                                <MenuItem disabled>Yüklənir...</MenuItem>
                            ) : (
                                plateNumbers.map(car => (
                                    <MenuItem key={car.id} value={car.plateNumber}>
                                        {car.plateNumber}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>

                    <TextField
                        size="small"
                        className="refund-sale-search"
                        placeholder="Axtar..."
                        value={plateSearch}
                        onChange={(e) => setPlateSearch(e.target.value)}
                        disabled={buyerType === "Əl ilə" || buyerType === "Umico" || searchDisabled}
                    />
                </Box>
            </Box>

            <Divider className="add-sale-divider" />

            {buyerType === "Maşın" && (
                <TableContainer
                    component={Paper}
                    className={activeLog ? "add-sale-active-table" : "add-sale-table"}
                    elevation={0}
                >
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>#No</strong></TableCell>
                                <TableCell><strong>Tam Ad</strong></TableCell>
                                <TableCell><strong>Əlaqə nömrəsi</strong></TableCell>
                                <TableCell><strong>Model</strong></TableCell>
                                <TableCell><strong>Nömrə nişanı</strong></TableCell>
                                <TableCell><strong>Seç</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logsLoading ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                                </TableRow>
                            ) : paginatedVisibleLogs.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">Məlumat tapılmadı</TableCell>
                                </TableRow>
                            ) : (
                                paginatedVisibleLogs.map((emp, index) => (
                                    <TableRow key={emp.id}>
                                        <TableCell>{"#" + String(emp.serialNo || emp.id).padStart(4, "0")}</TableCell>

                                        <TableCell>{emp.fullName}</TableCell>
                                        <TableCell>+994 {emp.phoneNumber}</TableCell>
                                        <TableCell>{emp.model}</TableCell>
                                        <TableCell>{emp.plateNumber}</TableCell>
                                        <TableCell >
                                            <Button
                                                variant="contained"
                                                size="small"
                                                className={activeLog ? "add-sale-button back" : "add-sale-button"}
                                                onClick={() => {
                                                    if (activeLog) {

                                                        setSelectedProducts([]);
                                                        setKm("");
                                                        setNextKm("");
                                                        setSelectedCategory("all");
                                                        setSelectedSubCategory("");
                                                        setPaymentType("Naxd");
                                                        setSearchDisabled(false);
                                                        setSearchTerm("");
                                                        setActiveLog(null);
                                                        handleSelectPlate("all");
                                                    } else {
                                                        setActiveLog(emp);
                                                        handleSelectPlate(emp.plateNumber);
                                                        setSearchDisabled(true);
                                                    }
                                                }}
                                            >
                                                {activeLog ? "GERİ" : "SEC"}
                                            </Button>

                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

            )}

            {!activeLog && visibleLogs.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                        size="small"
                    />
                </Box>
            )}

            {(activeLog && buyerType === "Maşın") || buyerType === "Əl ilə" || buyerType === "Umico" ? (
                <Box>
                    <Box className="sale-extra-wrapper" style={{ height: extraHeight }} >

                        {isMobileView ? (
                            <>
                                <Box className="sale-right">
                                    <Box className="right-top-filters" style={{ display: 'flex', gap: 12 }}>
                                        <Box style={{ display: 'flex', gap: '12px' }}>
                                            <FormControl size="small" className="filter-item" sx={{ width: 150 }}>
                                                <InputLabel>Kateqoriya</InputLabel>
                                                <Select
                                                    className="all-select-button"
                                                    value={selectedCategory}
                                                    label="Kateqoriya"
                                                    onChange={(e) => {
                                                        const cat = e.target.value;
                                                        setSelectedCategory(cat);

                                                        if (cat === "all") {

                                                            setSelectedSubCategory("");
                                                        } else {
                                                            setSelectedSubCategory(subCategoryOptions[cat][0]);
                                                        }
                                                    }}
                                                    MenuProps={{
                                                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                        transformOrigin: { vertical: "top", horizontal: "left" },
                                                        getContentAnchorEl: null,
                                                    }}


                                                >
                                                    <MenuItem value="all">Hamısı</MenuItem>
                                                    {categoryOptions.map((cat, idx) => (
                                                        <MenuItem key={idx} value={cat}>{cat}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            {selectedCategory !== "all" && (
                                                <FormControl size="small" className="filter-item" sx={{ width: 150 }}>
                                                    <InputLabel>Alt-kateqoriya</InputLabel>
                                                    <Select
                                                        className="all-select-button"
                                                        label="Alt-kateqoriya"
                                                        value={selectedSubCategory}
                                                        onChange={(e) => setSelectedSubCategory(e.target.value)}
                                                        MenuProps={{
                                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                                            getContentAnchorEl: null,
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 300,
                                                                    overflowY: "auto"
                                                                }
                                                            }
                                                        }}

                                                    >
                                                        {subCategoryOptions[selectedCategory]?.map((sub, idx) => (
                                                            <MenuItem key={idx} value={sub}>{sub}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}

                                            {(buyerType === "Maşın" || buyerType === "Əl ilə") && (
                                                <FormControl fullWidth size="small" sx={{ width: 150 }}>
                                                    <Select
                                                        value=""
                                                        displayEmpty
                                                        renderValue={() => (
                                                            <span style={{ fontWeight: 400 }}>
                                                                Xidmətlər
                                                            </span>
                                                        )}
                                                        onChange={(e) => handleServiceSelect(e.target.value)}
                                                        MenuProps={{
                                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                                            getContentAnchorEl: null,
                                                            PaperProps: {
                                                                style: {
                                                                    height: 300
                                                                }
                                                            }
                                                        }}

                                                    >
                                                        {servicesList.map((service, index) => (
                                                            <MenuItem key={index} value={service}>{service}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}

                                        </Box>
                                        <TextField
                                            className="add-sale-search"
                                            size="small"
                                            placeholder="Axtar..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Box>

                                    <TableContainer component={Paper} className="inner-table-right" elevation={0}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Məhsul</TableCell>
                                                    <TableCell>Qiymət</TableCell>
                                                    <TableCell>Ədəd / Litr</TableCell>
                                                    {buyerType === "Maşın" ? <TableCell>Endirim</TableCell> : null}
                                                    <TableCell>Kod</TableCell>
                                                    <TableCell>Yanacaq</TableCell>
                                                    <TableCell>Seçimlər</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {productsLoading ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Yüklənir...</TableCell>
                                                    </TableRow>
                                                ) : paginatedProducts.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Məlumat tapılmadı</TableCell>
                                                    </TableRow>
                                                ) : (
                                                    paginatedProducts.map((prod, idx) => (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>
                                                                {(() => {
                                                                    if (prod.subCategory === "Antifriz") {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else if (prod.litr) {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else {

                                                                        return <span>{prod.name}</span>;
                                                                    }
                                                                })()}
                                                            </TableCell>
                                                            <TableCell>{prod.price}₼</TableCell>
                                                            <TableCell>{((prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı"))
                                                                ? `${prod.totalLiter || prod.quantity} Litr`
                                                                : `${prod.quantity} Ədəd`
                                                            }</TableCell>
                                                            {buyerType === "Maşın"
                                                                ? <TableCell>{prod.discountAmount || 0}₼</TableCell>
                                                                : null}
                                                            <TableCell>{prod.code || "-"}</TableCell>
                                                            <TableCell>{prod.fuelType || "-"}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    disabled={lockClick && animatedId === prod.id}
                                                                    className={`add-sale-button ${animatedId === prod.id ? "sec-animate sec-success" : ""}`}
                                                                    onClick={() => handleAddProduct(prod)}
                                                                >
                                                                    {animatedId === prod.id ? "✔" : "SEC"}
                                                                </Button>

                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {filteredProducts.length > productsPerPage && (
                                        <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                                            <Pagination
                                                count={totalProductPages}
                                                page={productPage}
                                                onChange={(e, value) => setProductPage(value)}
                                                color="primary"
                                                variant="outlined"
                                                shape="rounded"
                                                size="small"
                                            />
                                        </Box>
                                    )}
                                </Box>

                                <Box className="sale-left">
                                    <TableContainer component={Paper} className="inner-table-left" elevation={0}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Məhsul</TableCell>
                                                    <TableCell>Qiymət</TableCell>
                                                    <TableCell>Ədəd / Litr</TableCell>
                                                    <TableCell>Cəmi</TableCell>
                                                    {buyerType === "Maşın" ? <TableCell>Endirim</TableCell> : null}
                                                    <TableCell>Kod</TableCell>
                                                    <TableCell>Yanacaq</TableCell>
                                                    <TableCell>Seçimlər</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedProducts.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Seçilmiş məhsul yoxdur</TableCell>
                                                    </TableRow>
                                                ) : (
                                                    selectedProducts.map((prod) => (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>
                                                                {(() => {


                                                                    if (prod.isService) {
                                                                        return (
                                                                            <span>
                                                                                {truncateText(prod.name, 25)}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    if (prod.subCategory === "Antifriz") {
                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    if (prod.litr) {
                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    return <span>{prod.name}</span>;

                                                                })()}

                                                            </TableCell>
                                                            <TableCell>
                                                                {prod.isService ? (
                                                                    <TextField
                                                                        size="small"
                                                                        value={prod.price}
                                                                        variant="outlined"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (window.innerWidth <= 1300) {
                                                                                setCurrentQtyId(prod.id);
                                                                                setServiceTempPrice(prod.price.toString());
                                                                                setOpenServicePriceNumpad(true);
                                                                            }
                                                                        }}
                                                                        inputProps={{
                                                                            style: { width: 35, height: 9, fontSize: 13, textAlign: "center" },
                                                                            readOnly: window.innerWidth <= 1300,
                                                                            inputProps: {
                                                                                onKeyDown: (e) => {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }
                                                                        }}

                                                                    />
                                                                ) : (
                                                                    `${prod.price}₼`
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {prod.isService ? "-" : (
                                                                    <TextField
                                                                        size="small"
                                                                        value={prod.quantity}
                                                                        inputProps={{
                                                                            style: { width: 35, height: 9, fontSize: 13, textAlign: "center" },
                                                                            readOnly: window.innerWidth <= 1300
                                                                        }}
                                                                        onClick={() => {

                                                                            if (window.innerWidth <= 1300) {
                                                                                const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                                                                                setCurrentQtyId(prod.id);
                                                                                setTempQty(prod.quantity.toString());


                                                                                if (isOil) {
                                                                                    setNumpadMode("price");
                                                                                } else {

                                                                                    setNumpadMode("quantity");
                                                                                }

                                                                                setOpenQtyNumpad(true);
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {

                                                                            if (window.innerWidth > 1300) {
                                                                                let v = e.target.value;
                                                                                const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                                                                                if (isOil) {

                                                                                    if (v === "" || /^\d*\.?\d*$/.test(v)) {
                                                                                        const numV = parseFloat(v);
                                                                                        if (!isNaN(numV) && numV > 999) return;
                                                                                        handleQuantityChange(prod.id, v);
                                                                                    }
                                                                                } else {

                                                                                    if (v === "") {
                                                                                        handleQuantityChange(prod.id, "");
                                                                                        return;
                                                                                    }
                                                                                    if (v === "0") {
                                                                                        handleQuantityChange(prod.id, 1);
                                                                                        return;
                                                                                    }
                                                                                    let cleanV = v.replace(/[^\d]/g, "").slice(0, 3);
                                                                                    if (cleanV.startsWith("0")) cleanV = cleanV.replace(/^0+/, "");
                                                                                    const numV = parseInt(cleanV);
                                                                                    if (numV > 999) return;
                                                                                    handleQuantityChange(prod.id, cleanV === "" ? "" : numV);
                                                                                }
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {

                                                                            let v = e.target.value;
                                                                            const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                                                                            if (isOil) {
                                                                                let num = parseFloat(v);
                                                                                if (isNaN(num) || num < 0.01) handleQuantityChange(prod.id, 0.01);
                                                                                else if (num > 999) handleQuantityChange(prod.id, 999);
                                                                                else handleQuantityChange(prod.id, num);
                                                                            } else {
                                                                                let num = parseInt(v);
                                                                                if (isNaN(num) || num < 1) handleQuantityChange(prod.id, 1);
                                                                                else if (num > 999) handleQuantityChange(prod.id, 999);
                                                                                else handleQuantityChange(prod.id, num);
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            </TableCell>
                                                            <TableCell>{formatPrice(prod.totalPrice)}₼</TableCell>
                                                            {buyerType === "Maşın" && (
                                                                <TableCell>{prod.isService ? "-" : `${formatPrice(prod.discountAmount || 0)}₼`}</TableCell>
                                                            )}
                                                            <TableCell>{prod.isService ? "-" : (prod.code || "-")}</TableCell>
                                                            <TableCell>{prod.isService ? "-" : (prod.fuelType || "-")}</TableCell>
                                                            <TableCell>
                                                                <Button size="small" color="error" variant="contained" onClick={() => handleRemoveProduct(prod.id)}>SIL</Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Box className="sale-footer-left">
                                        <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                            {buyerType === "Maşın" && (

                                                <>
                                                    <TextField
                                                        label="Hal-hazırda"
                                                        size="small"
                                                        type="number"
                                                        value={km}
                                                        sx={{ width: "120px" }}
                                                        InputProps={{
                                                            readOnly: window.innerWidth <= 1300,
                                                            inputProps: {
                                                                onKeyDown: (e) => {
                                                                    if (e.key === "-" || e.key === "e" || e.key === "+") e.preventDefault();
                                                                },
                                                                min: 0,
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            if (window.innerWidth <= 1300) setOpenNumpad(true);
                                                        }}
                                                        onChange={(e) => {
                                                            if (window.innerWidth > 1300) {
                                                                let v = e.target.value.slice(0, 6);
                                                                if (v.length > 1 && v.startsWith("0")) v = v.replace(/^0+/, "");
                                                                setKm(v);
                                                            }
                                                        }}
                                                    />

                                                    <TextField
                                                        label="Sonrakı"
                                                        size="small"
                                                        type="number"
                                                        value={nextKm}
                                                        sx={{ width: "120px" }}
                                                        InputProps={{
                                                            readOnly: window.innerWidth <= 1300,
                                                            inputProps: {
                                                                onKeyDown: (e) => {
                                                                    if (e.key === "-" || e.key === "e" || e.key === "+") e.preventDefault();
                                                                },
                                                                min: 0,
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            if (window.innerWidth <= 1300) setOpenNextNumpad(true);
                                                        }}
                                                        onChange={(e) => {
                                                            if (window.innerWidth > 1300) {
                                                                let v = e.target.value.slice(0, 6);
                                                                if (v.length > 1 && v.startsWith("0")) v = v.replace(/^0+/, "");
                                                                setNextKm(v);
                                                            }
                                                        }}
                                                    />
                                                </>

                                            )}

                                            <TextField
                                                select
                                                size="small"
                                                label="Ödəniş"
                                                value={paymentType}
                                                onChange={(e) => setPaymentType(e.target.value)}
                                                sx={{ width: "130px" }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        PaperProps: {
                                                            style: {
                                                                marginBottom: 4,
                                                                minWidth: 130,
                                                            },
                                                        },
                                                        anchorOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left",
                                                        },
                                                        transformOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left",
                                                        },
                                                        getContentAnchorEl: null,
                                                    },
                                                }}
                                            >
                                                <MenuItem value="Naxd">Nəğd</MenuItem>
                                                <MenuItem value="Kart">Kart</MenuItem>
                                                <MenuItem value="Kart/Naxd">Kart/Nəğd</MenuItem>
                                                <MenuItem value="POS-terminal">POS-terminal</MenuItem>
                                                <MenuItem value="Naxd/POS-terminal">Nəğd/POS-terminal</MenuItem>
                                            </TextField>
                                        </Box>


                                    </Box>

                                </Box>
                            </>
                        ) : (
                            <>
                                <Box className="sale-left">
                                    <TableContainer component={Paper} className="inner-table-left" elevation={0}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Məhsul</TableCell>
                                                    <TableCell>Qiymət</TableCell>
                                                    <TableCell>Ədəd / Litr</TableCell>
                                                    <TableCell>Cəmi</TableCell>
                                                    {buyerType === "Maşın" ? <TableCell>Endirim</TableCell> : null}
                                                    <TableCell>Kod</TableCell>
                                                    <TableCell>Yanacaq</TableCell>
                                                    <TableCell>Seçimlər</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedProducts.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Seçilmiş məhsul yoxdur</TableCell>
                                                    </TableRow>
                                                ) : (
                                                    selectedProducts.map((prod) => (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>
                                                                {(() => {


                                                                    if (prod.isService) {
                                                                        return (
                                                                            <span>
                                                                                {truncateText(prod.name, 25)}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    if (prod.subCategory === "Antifriz") {
                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    if (prod.litr) {
                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    }


                                                                    return <span>{prod.name}</span>;

                                                                })()}

                                                            </TableCell>
                                                            <TableCell>
                                                                {prod.isService ? (
                                                                    <TextField
                                                                        size="small"
                                                                        value={prod.price}
                                                                        variant="outlined"
                                                                        onChange={(e) => {
                                                                            const val = e.target.value;

                                                                            if (/^[0-9]*[.,]?[0-9]*$/.test(val)) {
                                                                                handlePriceChange(prod.id, val);
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            let v = e.target.value;


                                                                            if (v === "" || v === ".") {
                                                                                handlePriceChange(prod.id, "0");
                                                                                return;
                                                                            }


                                                                            if (v.endsWith(".")) {
                                                                                v = v.slice(0, -1);
                                                                            }

                                                                            handlePriceChange(prod.id, v);
                                                                        }}

                                                                        inputProps={{
                                                                            style: { width: 35, height: 9, fontSize: 13, textAlign: "center" }
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    `${prod.price}₼`
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {prod.isService ? "-" : (
                                                                    <TextField
                                                                        size="small"
                                                                        value={prod.quantity}
                                                                        inputProps={{
                                                                            style: { width: 35, height: 9, fontSize: 13, textAlign: "center" },
                                                                            readOnly: window.innerWidth <= 1300
                                                                        }}
                                                                        onClick={() => {
                                                                            if (window.innerWidth <= 1300) {
                                                                                setCurrentQtyId(prod.id);
                                                                                setTempQty(prod.quantity.toString());
                                                                                setOpenQtyNumpad(true);
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            if (window.innerWidth > 1300) {
                                                                                let v = e.target.value;
                                                                                const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                                                                                if (isOil) {

                                                                                    if (v === "" || /^\d*\.?\d*$/.test(v)) {


                                                                                        const numV = parseFloat(v);
                                                                                        if (!isNaN(numV) && numV > 999) return;


                                                                                        handleQuantityChange(prod.id, v);
                                                                                    }
                                                                                } else {

                                                                                    if (v === "") {
                                                                                        handleQuantityChange(prod.id, "");
                                                                                        return;
                                                                                    }
                                                                                    if (v === "0") {
                                                                                        handleQuantityChange(prod.id, 1);
                                                                                        return;
                                                                                    }

                                                                                    let cleanV = v.replace(/[^\d]/g, "").slice(0, 3);
                                                                                    if (cleanV.startsWith("0")) cleanV = cleanV.replace(/^0+/, "");

                                                                                    const numV = parseInt(cleanV);
                                                                                    if (numV > 999) return;

                                                                                    handleQuantityChange(prod.id, cleanV === "" ? "" : numV);
                                                                                }
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            let v = e.target.value;
                                                                            const isOil = prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı";

                                                                            if (isOil) {
                                                                                let num = parseFloat(v);

                                                                                if (isNaN(num) || num < 0.01) handleQuantityChange(prod.id, 0.01);
                                                                                else if (num > 999) handleQuantityChange(prod.id, 999);
                                                                                else handleQuantityChange(prod.id, num);
                                                                            } else {
                                                                                let num = parseInt(v);
                                                                                if (isNaN(num) || num < 1) handleQuantityChange(prod.id, 1);
                                                                                else if (num > 999) handleQuantityChange(prod.id, 999);
                                                                                else handleQuantityChange(prod.id, num);
                                                                            }
                                                                        }}
                                                                    />

                                                                )}

                                                            </TableCell>
                                                            <TableCell>{formatPrice(prod.totalPrice)}₼</TableCell>
                                                            {buyerType === "Maşın" && (
                                                                <TableCell>{prod.isService ? "-" : `${formatPrice(prod.discountAmount || 0)}₼`}</TableCell>
                                                            )}
                                                            <TableCell>{prod.isService ? "-" : (prod.code || "-")}</TableCell>
                                                            <TableCell>{prod.isService ? "-" : (prod.fuelType || "-")}</TableCell>
                                                            <TableCell>
                                                                <Button size="small" color="error" variant="contained" onClick={() => handleRemoveProduct(prod.id)}>SIL</Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Box className="sale-footer-left">
                                        <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                            {buyerType === "Maşın" && (


                                                <>
                                                    <TextField
                                                        label="Hal-hazırda"
                                                        size="small"
                                                        type="number"
                                                        value={km}
                                                        sx={{ width: "120px" }}
                                                        InputProps={{
                                                            readOnly: window.innerWidth <= 1300,
                                                            inputProps: {
                                                                onKeyDown: (e) => {
                                                                    if (e.key === "-" || e.key === "e" || e.key === "+") e.preventDefault();
                                                                },
                                                                min: 0,
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            if (window.innerWidth <= 1300) setOpenNumpad(true);
                                                        }}
                                                        onChange={(e) => {
                                                            if (window.innerWidth > 1300) {
                                                                let v = e.target.value.slice(0, 6);
                                                                if (v.length > 1 && v.startsWith("0")) v = v.replace(/^0+/, "");
                                                                setKm(v);
                                                            }
                                                        }}
                                                    />

                                                    <TextField
                                                        label="Sonrakı"
                                                        size="small"
                                                        type="number"
                                                        value={nextKm}
                                                        sx={{ width: "120px" }}
                                                        InputProps={{
                                                            readOnly: window.innerWidth <= 1300,
                                                            inputProps: {
                                                                onKeyDown: (e) => {
                                                                    if (e.key === "-" || e.key === "e" || e.key === "+") e.preventDefault();
                                                                },
                                                                min: 0,
                                                            },
                                                        }}
                                                        onClick={() => {
                                                            if (window.innerWidth <= 1300) setOpenNextNumpad(true);
                                                        }}
                                                        onChange={(e) => {
                                                            if (window.innerWidth > 1300) {
                                                                let v = e.target.value.slice(0, 6);
                                                                if (v.length > 1 && v.startsWith("0")) v = v.replace(/^0+/, "");
                                                                setNextKm(v);
                                                            }
                                                        }}
                                                    />
                                                </>

                                            )}

                                            <TextField
                                                select
                                                size="small"
                                                label="Ödəniş"
                                                value={paymentType}
                                                onChange={(e) => setPaymentType(e.target.value)}
                                                sx={{ width: "130px" }}
                                                SelectProps={{
                                                    MenuProps: {
                                                        PaperProps: {
                                                            style: {
                                                                marginBottom: 4,
                                                                minWidth: 130,
                                                            },
                                                        },
                                                        anchorOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left",
                                                        },
                                                        transformOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "left",
                                                        },
                                                        getContentAnchorEl: null,
                                                    },
                                                }}
                                            >
                                                <MenuItem value="Naxd">Nəğd</MenuItem>
                                                <MenuItem value="Kart">Kart</MenuItem>
                                                <MenuItem value="Kart/Naxd">Kart/Nəğd</MenuItem>
                                                <MenuItem value="POS-terminal">POS-terminal</MenuItem>
                                                <MenuItem value="Naxd/POS-terminal">Nəğd/POS-terminal</MenuItem>
                                            </TextField>
                                        </Box>


                                    </Box>

                                </Box>

                                <Box className="sale-right">
                                    <Box className="right-top-filters" style={{ display: 'flex', gap: 12 }}>
                                        <Box style={{ display: 'flex', gap: '12px' }}>
                                            <FormControl size="small" className="filter-item" sx={{ width: 150 }}>
                                                <InputLabel>Kateqoriya</InputLabel>
                                                <Select
                                                    className="all-select-button"
                                                    value={selectedCategory}
                                                    label="Kateqoriya"
                                                    onChange={(e) => {
                                                        const cat = e.target.value;
                                                        setSelectedCategory(cat);

                                                        if (cat === "all") {

                                                            setSelectedSubCategory("");
                                                        } else {
                                                            setSelectedSubCategory(subCategoryOptions[cat][0]);
                                                        }
                                                    }}
                                                    MenuProps={{
                                                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                        transformOrigin: { vertical: "top", horizontal: "left" },
                                                        getContentAnchorEl: null,
                                                    }}


                                                >
                                                    <MenuItem value="all">Hamısı</MenuItem>
                                                    {categoryOptions.map((cat, idx) => (
                                                        <MenuItem key={idx} value={cat}>{cat}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            {selectedCategory !== "all" && (
                                                <FormControl size="small" className="filter-item" sx={{ width: 150 }}>
                                                    <InputLabel>Alt-kateqoriya</InputLabel>
                                                    <Select
                                                        className="all-select-button"
                                                        label="Alt-kateqoriya"
                                                        value={selectedSubCategory}
                                                        onChange={(e) => setSelectedSubCategory(e.target.value)}
                                                        MenuProps={{
                                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                                            getContentAnchorEl: null,
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 300,
                                                                    overflowY: "auto"
                                                                }
                                                            }
                                                        }}

                                                    >
                                                        {subCategoryOptions[selectedCategory]?.map((sub, idx) => (
                                                            <MenuItem key={idx} value={sub}>{sub}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}

                                            {(buyerType === "Maşın" || buyerType === "Əl ilə") && (
                                                <FormControl fullWidth size="small" sx={{ width: 150 }}>
                                                    <Select
                                                        value=""
                                                        displayEmpty
                                                        renderValue={() => (
                                                            <span style={{ fontWeight: 400 }}>
                                                                Xidmətlər
                                                            </span>
                                                        )}
                                                        onChange={(e) => handleServiceSelect(e.target.value)}
                                                        MenuProps={{
                                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                                            getContentAnchorEl: null,
                                                            PaperProps: {
                                                                style: {
                                                                    height: 300
                                                                }
                                                            }
                                                        }}

                                                    >
                                                        {servicesList.map((service, index) => (
                                                            <MenuItem key={index} value={service}>{service}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}

                                        </Box>
                                        <TextField
                                            className="add-sale-search"
                                            size="small"
                                            placeholder="Axtar..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Box>

                                    <TableContainer component={Paper} className="inner-table-right" elevation={0}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Məhsul</TableCell>
                                                    <TableCell>Qiymət</TableCell>
                                                    <TableCell>Ədəd / Litr</TableCell>
                                                    {buyerType === "Maşın" ? <TableCell>Endirim</TableCell> : null}
                                                    <TableCell>Kod</TableCell>
                                                    <TableCell>Yanacaq</TableCell>
                                                    <TableCell>Seçimlər</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {productsLoading ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Yüklənir...</TableCell>
                                                    </TableRow>
                                                ) : paginatedProducts.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center">Məlumat tapılmadı</TableCell>
                                                    </TableRow>
                                                ) : (
                                                    paginatedProducts.map((prod, idx) => (
                                                        <TableRow key={prod.id}>
                                                            <TableCell>
                                                                {(() => {
                                                                    if (prod.subCategory === "Antifriz") {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L {prod.color}</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else if (prod.litr) {

                                                                        return (
                                                                            <span>
                                                                                <strong>{prod.litr}L</strong> {prod.name}
                                                                            </span>
                                                                        );
                                                                    } else {

                                                                        return <span>{prod.name}</span>;
                                                                    }
                                                                })()}
                                                            </TableCell>
                                                            <TableCell>{prod.price}₼</TableCell>
                                                            <TableCell>{((prod.subCategory === "Motor yağı" || prod.subCategory === "Transmissiya yağı"))
                                                                ? `${prod.totalLiter || prod.quantity} Litr`
                                                                : `${prod.quantity} Ədəd`
                                                            }</TableCell>
                                                            {buyerType === "Maşın"
                                                                ? <TableCell>{prod.discountAmount || 0}₼</TableCell>
                                                                : null}
                                                            <TableCell>{prod.code || "-"}</TableCell>
                                                            <TableCell>{prod.fuelType || "-"}</TableCell>
                                                            <TableCell>
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    disabled={lockClick && animatedId === prod.id}
                                                                    className={`add-sale-button ${animatedId === prod.id ? "sec-animate sec-success" : ""}`}
                                                                    onClick={() => handleAddProduct(prod)}
                                                                >
                                                                    {animatedId === prod.id ? "✔" : "SEC"}
                                                                </Button>

                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {filteredProducts.length > productsPerPage && (
                                        <Box sx={{ display: 'flex', justifyContent: 'right', p: 2, mt: 1 }}>
                                            <Pagination
                                                count={totalProductPages}
                                                page={productPage}
                                                onChange={(e, value) => setProductPage(value)}
                                                color="primary"
                                                variant="outlined"
                                                shape="rounded"
                                                size="small"
                                            />
                                        </Box>
                                    )}
                                </Box>


                            </>
                        )}





                    </Box>
                    <Box className="sale-bottom-footer" style={{ padding: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography variant="subtitle1" className="sale-title" sx={{ fontWeight: 700 }}>
                            Ödəniləcək: {formatPrice(totalAmount)}₼
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => setOpenPayment(true)}
                            disabled={selectedProducts.length === 0}
                        >
                            Əlavə et
                        </Button>
                    </Box>
                </Box>
            ) : null}

            {openPayment && (
                <Box
                    className="payment-popup"
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.45)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                >
                    <Box
                        sx={{
                            width: 380,
                            background: "#fff",
                            borderRadius: 2,
                            p: 3,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Ödəniş</Typography>
                        <Typography>Ümumi məbləğ: <strong>{formatPrice(totalAmount)}₼</strong></Typography>

                        {(paymentType === "Naxd" || paymentType === "Kart/Naxd" || paymentType === "Naxd/POS-terminal") && (
                            <TextField label="Nağd məbləğ" type="text" value={cash} onChange={handleCashChange} />
                        )}
                        {(paymentType === "Kart" || paymentType === "Kart/Naxd" || paymentType === "POS-terminal" || paymentType === "Naxd/POS-terminal") && (
                            <TextField label={paymentType.includes("POS") ? "POS-terminal məbləği" : "Kart məbləği"} type="text" value={card} onChange={handleCardChange} />
                        )}

                        <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                            Geri qaytarılacaq:{" "}
                            {(paymentType === "Naxd")
                                ? formatPrice(change)
                                : (paymentType === "Kart" || paymentType === "POS-terminal")
                                    ? Number(card || 0) > totalAmount
                                        ? formatPrice(Number(card || 0) - totalAmount)
                                        : "0"
                                    : (paymentType === "Kart/Naxd" || paymentType === "Naxd/POS-terminal")
                                        ? Number(cash || 0) + Number(card || 0) > totalAmount
                                            ? formatPrice(Number(cash || 0) + Number(card || 0) - totalAmount)
                                            : "0"
                                        : "0"} ₼
                        </Typography>

                        <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="success"
                                disabled={Number(cash || 0) + Number(card || 0) < totalAmount}
                                onClick={() => {
                                    handleConfirmSale();
                                }}
                            >
                                Təsdiqlə
                            </Button>


                            <Button
                                fullWidth
                                variant="contained"
                                color="error"
                                onClick={() => {
                                    setOpenPayment(false);
                                    setCash(0);
                                    setCard(0);
                                    setChange(0);
                                }}
                            >
                                Bağla
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}

            {openNumpad && (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={() => setOpenNumpad(false)}
                >
                    <Box
                        sx={{
                            width: 280,
                            bgcolor: "#fff",
                            borderRadius: 3,
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Box
                            sx={{
                                height: 50,
                                bgcolor: "#e7e7e7ff",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                px: 2,
                                fontSize: 24,
                                fontFamily: "monospace"
                            }}
                        >
                            {km || "0"}
                        </Box>

                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1 }}>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                <Button
                                    key={num}
                                    variant="outlined"
                                    sx={{
                                        height: 60,
                                        fontSize: 20,
                                        borderRadius: 2,
                                        border: "1px solid black",
                                        bgcolor: "#ffffffff",
                                        color: "black",
                                        "&:hover": { bgcolor: "#ffffffff" }
                                    }}
                                    onClick={() => addDigit(num.toString())}

                                >
                                    {num}
                                </Button>
                            ))}

                            <Button
                                variant="contained"
                                color="error"
                                sx={{ height: 60, fontSize: 35, borderRadius: 2 }}
                                onClick={() => setKm(prev => prev.slice(0, -1))}
                            >
                                ⌫
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    height: 60,
                                    fontSize: 20,
                                    borderRadius: 2,
                                    bgcolor: "#ffffffff",
                                    border: "1px solid black",
                                    color: "black",

                                    "&:hover": { bgcolor: "#ffffffff" }
                                }}
                                onClick={() => addDigit("0")}

                            >
                                0
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                sx={{ height: 60, fontSize: 18, borderRadius: 2 }}
                                onClick={() => setOpenNumpad(false)}
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}

            {openNextNumpad && (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={() => setOpenNextNumpad(false)}
                >
                    <Box
                        sx={{
                            width: 280,
                            bgcolor: "#fff",
                            borderRadius: 3,
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >

                        <Box
                            sx={{
                                height: 50,
                                bgcolor: "#e7e7e7ff",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                px: 2,
                                fontSize: 24,
                                fontFamily: "monospace"
                            }}
                        >
                            {nextKm || "0"}
                        </Box>


                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1 }}>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                                <Button
                                    key={num}
                                    variant="outlined"
                                    sx={{
                                        height: 60,
                                        fontSize: 20,
                                        borderRadius: 2,
                                        border: "1px solid black",
                                        bgcolor: "#fff",
                                        color: "black"
                                    }}
                                    onClick={() => addNextKmDigit(num.toString())}
                                >
                                    {num}
                                </Button>
                            ))}


                            <Button
                                variant="contained"
                                color="error"
                                sx={{ height: 60, fontSize: 35, borderRadius: 2 }}
                                onClick={() => setNextKm(prev => prev.slice(0, -1))}
                            >
                                ⌫
                            </Button>


                            <Button
                                variant="outlined"
                                sx={{
                                    height: 60,
                                    fontSize: 20,
                                    borderRadius: 2,
                                    bgcolor: "#fff",
                                    border: "1px solid black",
                                    color: "black"
                                }}
                                onClick={() => addNextKmDigit("0")}
                            >
                                0
                            </Button>


                            <Button
                                variant="contained"
                                color="success"
                                sx={{ height: 60, fontSize: 18, borderRadius: 2 }}
                                onClick={() => setOpenNextNumpad(false)}
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}


            {openServicePriceNumpad && (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={() => setOpenServicePriceNumpad(false)}
                >
                    <Box
                        sx={{
                            width: 280,
                            bgcolor: "#fff",
                            borderRadius: 3,
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >


                        <Box
                            sx={{
                                height: 50,
                                bgcolor: "#e7e7e7ff",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                px: 2,
                                fontSize: 24,
                                fontFamily: "monospace"
                            }}
                        >
                            {serviceTempPrice || "0"}
                        </Box>


                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1 }}>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                <Button
                                    key={num}
                                    variant="outlined"
                                    sx={{
                                        height: 60, fontSize: 20, borderRadius: 2,
                                        border: "1px solid black", bgcolor: "#fff", color: "black",
                                        "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                    }}
                                    onClick={() => setServiceTempPrice(prev => {

                                        let newVal = prev === "0" ? num.toString() : prev + num;
                                        return newVal.slice(0, 7);
                                    })}
                                >
                                    {num}
                                </Button>
                            ))}


                            <Button
                                variant="contained"
                                color="error"
                                sx={{ height: 60, fontSize: 25, borderRadius: 2 }}
                                onClick={() => setServiceTempPrice(prev => prev.slice(0, -1))}
                            >
                                ⌫
                            </Button>


                            <Button
                                variant="outlined"
                                sx={{
                                    height: 60, fontSize: 20, borderRadius: 2,
                                    border: "1px solid black", bgcolor: "#fff", color: "black",
                                    "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                }}
                                onClick={() => setServiceTempPrice(prev => {

                                    if (prev === "0") return prev;
                                    return (prev + "0").slice(0, 7);
                                })}
                            >
                                0
                            </Button>


                            <Button
                                variant="outlined"
                                sx={{
                                    height: 60, fontSize: 25, fontWeight: "bold", borderRadius: 2,
                                    border: "1px solid black", bgcolor: "#fff", color: "black",
                                    "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                }}
                                onClick={() => setServiceTempPrice(prev => {

                                    if (prev.includes(".")) return prev;
                                    if (prev === "") return "0.";
                                    return prev + ".";
                                })}
                            >
                                .
                            </Button>


                            <Button
                                variant="contained"
                                color="success"
                                sx={{ height: 60, fontSize: 18, borderRadius: 2, gridColumn: "span 3", mt: 1 }}
                                onClick={() => {

                                    let cleanPrice = serviceTempPrice;
                                    if (cleanPrice.endsWith(".")) {
                                        cleanPrice = cleanPrice.slice(0, -1);
                                    }

                                    const finalPrice = (cleanPrice === "" || cleanPrice === ".") ? "0" : cleanPrice;

                                    handlePriceChange(currentQtyId, finalPrice);
                                    setOpenServicePriceNumpad(false);
                                    setServiceTempPrice("");
                                }}
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}

            {openQtyNumpad && (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                    onClick={() => setOpenQtyNumpad(false)}
                >
                    <Box
                        sx={{
                            width: 280,
                            bgcolor: "#fff",
                            borderRadius: 3,
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Box
                            sx={{
                                height: 50,
                                bgcolor: "#e7e7e7ff",
                                borderRadius: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                px: 2,
                                fontSize: 24,
                                fontFamily: "monospace"
                            }}
                        >
                            {tempQty || "0"}
                        </Box>
                        {openQtyNumpad && (
                            <Box
                                sx={{
                                    position: "fixed",
                                    inset: 0,
                                    bgcolor: "rgba(0,0,0,0.4)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 9999
                                }}
                                onClick={() => setOpenQtyNumpad(false)}
                            >
                                <Box
                                    sx={{
                                        width: 280,
                                        bgcolor: "#fff",
                                        borderRadius: 3,
                                        p: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >

                                    <Box
                                        sx={{
                                            height: 50,
                                            bgcolor: "#e7e7e7ff",
                                            borderRadius: 2,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            px: 2,
                                            fontSize: 24,
                                            fontFamily: "monospace"
                                        }}
                                    >
                                        {tempQty || "0"}
                                    </Box>

                                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1 }}>
                                        {(() => {
                                            const currentProd = selectedProducts.find(p => p.id === currentQtyId);

                                            const isOil = buyerType === "Maşın" &&
                                                (currentProd?.subCategory === "Motor yağı" || currentProd?.subCategory === "Transmissiya yağı");

                                            const handleAddDigit = (num) => {
                                                setTempQty(prev => {
                                                    let nextVal = prev + num;
                                                    if (parseFloat(nextVal) > 999) return prev;

                                                    if (nextVal.includes(".")) {
                                                        const parts = nextVal.split(".");
                                                        if (parts[1].length > 3) return prev;
                                                    }

                                                    if (nextVal.length > 1 && nextVal.startsWith("0") && !nextVal.startsWith("0.")) {
                                                        nextVal = nextVal.replace(/^0+/, "");
                                                    }
                                                    return nextVal;
                                                });
                                            };

                                            return (
                                                <>
                                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                                        <Button
                                                            key={num}
                                                            variant="outlined"
                                                            sx={{
                                                                height: 60, fontSize: 20, borderRadius: 2,
                                                                border: "1px solid black", bgcolor: "#fff", color: "black",
                                                                "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                                            }}
                                                            onClick={() => handleAddDigit(num.toString())}
                                                        >
                                                            {num}
                                                        </Button>
                                                    ))}


                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        sx={{ height: 60, fontSize: 35, borderRadius: 2 }}
                                                        onClick={() => setTempQty(prev => prev.length > 0 ? prev.slice(0, -1) : "")}
                                                    >
                                                        ⌫
                                                    </Button>


                                                    <Button
                                                        variant="outlined"
                                                        sx={{
                                                            height: 60, fontSize: 20, borderRadius: 2,
                                                            border: "1px solid black", bgcolor: "#fff", color: "black",
                                                            "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                                        }}
                                                        onClick={() => handleAddDigit("0")}
                                                    >
                                                        0
                                                    </Button>


                                                    {numpadMode === "price" ? (
                                                        <>
                                                            <Button
                                                                variant="outlined"
                                                                sx={{
                                                                    height: 60, fontSize: 25, fontWeight: "bold", borderRadius: 2,
                                                                    border: "1px solid black", bgcolor: "#fff", color: "black",
                                                                    "&:hover": { bgcolor: "#f5f5f5", border: "1px solid black" }
                                                                }}
                                                                onClick={() => {
                                                                    setTempQty(prev => {
                                                                        if (prev.includes(".") || prev === "") return prev === "" ? "0." : prev;
                                                                        return prev + ".";
                                                                    });
                                                                }}
                                                            >
                                                                .
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                sx={{ height: 60, fontSize: 18, borderRadius: 2, gridColumn: "span 3", mt: 1 }}
                                                                onClick={() => {
                                                                    let v = tempQty;
                                                                    const prod = selectedProducts.find(p => p.id === currentQtyId);
                                                                    const isOil =
                                                                        prod?.subCategory === "Motor yağı" ||
                                                                        prod?.subCategory === "Transmissiya yağı";

                                                                    if (isOil) {

                                                                        if (v === "" || v === ".") {
                                                                            v = "0.01";
                                                                        }


                                                                        if (v.endsWith(".")) {
                                                                            v = v.slice(0, -1);
                                                                        }

                                                                        let num = parseFloat(v);
                                                                        if (isNaN(num) || num < 0.01) num = 0.01;
                                                                        if (num > 999) num = 999;

                                                                        handleQuantityChange(currentQtyId, num);
                                                                    } else {

                                                                        let num = parseInt(v);
                                                                        if (isNaN(num) || num < 1) num = 1;
                                                                        if (num > 999) num = 999;

                                                                        handleQuantityChange(currentQtyId, num);
                                                                    }

                                                                    setOpenQtyNumpad(false);
                                                                }}

                                                            >
                                                                OK
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            sx={{ height: 60, fontSize: 18, borderRadius: 2 }}
                                                            onClick={() => {

                                                                let cleanVal = tempQty;
                                                                if (cleanVal.endsWith(".")) {
                                                                    cleanVal = cleanVal.slice(0, -1);
                                                                }


                                                                const finalVal = (cleanVal === "" || cleanVal === ".")
                                                                    ? (isOil ? 0.01 : 1)
                                                                    : cleanVal;

                                                                handleQuantityChange(currentQtyId, finalVal);
                                                                setOpenQtyNumpad(false);
                                                                setTempQty("");
                                                            }}
                                                        >
                                                            OK
                                                        </Button>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </Box>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
